import { parseJwt } from '../utils/helpers';

export const isBrowser = () => typeof window !== "undefined";

/**
 * Returns the user token from local storage if it exists, otherwise
 * returns an empty object.
 */
export const getTokenUser = () =>
  isBrowser() && window.localStorage.getItem("SN-BACKOFFICE-TOKEN")
    ? JSON.parse(window.localStorage.getItem("SN-BACKOFFICE-TOKEN"))
    : {}

const setToken = token => {
  return window.localStorage.setItem("SN-BACKOFFICE-TOKEN", JSON.stringify(token))
}

/**
 * Remove the token from the browser's local storage.
 *
 * @returns {void}
 */
export const destroyToken = () => {
  return window.localStorage.removeItem("SN-BACKOFFICE-TOKEN")
}

/**
 * Clear all data from the browser's local storage.
 *
 * @returns {void}
 */
export const clearStorage = () => {
  window.localStorage.clear();
}

/**
 * Handle the login process by saving the token in the browser's local storage.
 *
 * @param {string} token The JSON Web Token to save in the browser's local storage.
 *
 * @returns {void}
 */
export const handleLogin = (token) => {
  if (token !== undefined) {
    return setToken(token)
  }
  return
}

/**
 * Check if user is logged in by validating the presence of a valid token in browser's local storage.
 * The token is validated by parsing it and checking if it contains user information.
 * If the token is valid, the user object is returned, otherwise false.
 *
 * @returns {Object|boolean} user object if user is logged in, false otherwise
 */
export const isLoggedIn = () => {
  const user = getTokenUser()
  if (user.length > 0) {
    return parseJwt(user)
  }
  return false
}

export const handleLogout = callback => {
  destroyToken()
  clearStorage()
  if (callback) {
    window.location.href = '/';
  }
}


/**
 * Check if there is a token in the browser's local storage.
 * If token exists, parse it and return the user object.
 * Otherwise, return false.
 *
 * @returns {Object|boolean} user object if token exists, false otherwise
 */
export const parseToken = () => {
  const isTokens = getTokenUser()
  if (isTokens.length > 0) {
    return parseJwt(isTokens)
  }
  return false
}
